import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import VerifyEppReset from './VerifyEppReset';

const VerifyEppResetRoute: FuseRouteItemType = {
	path: '/epp-reset',
    element: <VerifyEppReset />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: null
};

export default VerifyEppResetRoute;
